import HorizontalRule from 'components/HorizontalRule';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Modal, ModalHeader, ModalBody, ModalFooter, UncontrolledTooltip } from 'reactstrap';
import { PRIORITY_FILTER } from 'components/AthleticTrainerModal/credentialHelpers';
import { downloadAllCredentials } from 'redux/ducks/Credentials';
import { get } from 'lodash';
import CredentialModal from '../CredentialModal';
import { computeReliabilityScore } from 'helpers/reliabilityScore';
import classNames from 'classnames';
import { AthleticTrainerService } from 'services/v2';
import { SHOW_TOOLTIP_COLUMNS, createOverflowChecker } from 'helpers/dashboard';
import { AddButton, DeleteButton } from 'components/V2/Buttons';
import CredentialsIssueModal from '../CredentialsIssueModal/CredentialsIssueModal';
import ToolTip from 'scenes/V2/ToolTip';

class ExperienceModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      isOverflowing: {},
      jobCount: 0,
      message: 'N/A',
      issueModalOpen: false,
    };
    this.columnRefs = {};
    SHOW_TOOLTIP_COLUMNS.experienceModal.forEach((column) => {
      this.columnRefs[column] = React.createRef();
    });
  }

  toggleIssueModal = () => {
    this.setState({ ...this.state, issueModalOpen: !this.state.issueModalOpen });
  };

  componentDidMount() {
    const checkOverflow = createOverflowChecker(
      'experienceModal',
      this.columnRefs,
      this.setState.bind(this)
    );
    this.resizeObserver = new ResizeObserver(checkOverflow);
    SHOW_TOOLTIP_COLUMNS.experienceModal.forEach((column) => {
      this.resizeObserver.observe(this.columnRefs[column].current);
    });
  }

  componentWillUnmount() {
    this.resizeObserver.disconnect();
  }

  onOpened = () => {
    const athleticTrainerService = new AthleticTrainerService(this.props.session);
    athleticTrainerService
      .getATStatistics(this.props.id)
      .then((data) => {
        this.setState({
          jobCount: data.job_count,
          message: data.message_for_eo,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  toggle = () => {
    this.setState({ open: !this.state.open });
    if (!this.state.open) {
      this.props.onClick();
      document.body.removeEventListener('touchmove', (e) => e.preventDefault(), { passive: false });
    } else document.body.addEventListener('touchmove', (e) => e.preventDefault());
  };

  onDownloadAllCredentials = () => {
    this.props.downloadAllCredentials(this.props.id);
  };

  getAT = () => {
    const { pendingApplicants, id } = this.props;
    const AT = pendingApplicants.find((at) => at.id === id);
    return AT;
  };

  showActions = () => {
    return this.props.from === 'applicants' || this.props.canDoAction;
  };

  onApprove = () => {
    this.toggle();
    this.props.onApprove();
  };

  onDecline = () => {
    this.toggle();
    this.props.onDecline();
  };

  showContactInformation = () => {
    const { job } = this.props;
    if (!job) return false;

    return ['confirmed', 'checked_in'].includes(job.currentState);
  };

  render() {
    const { id, companyName, reviewId } = this.props;
    const at = this.getAT();
    const profile = get(at, 'profile', {});

    if (at?.id !== id)
      return (
        <div className="experienceModal">
          <div
            className={classNames('plain-button', {
              'feedback-button': this.props.from === 'reviews',
              'modal-button': this.props.from !== 'reviews',
              'upcoming-button': this.props.from === 'upcoming',
            })}
            onClick={this.toggle}
            id={`atName-${reviewId}`}
            ref={this.columnRefs['atName']}
          >
            {this.props.children}
            {this.state.isOverflowing.atName && this.props.from === 'reviews' && (
              <UncontrolledTooltip target={`atName-${reviewId}`}>
                {this.props.children}
              </UncontrolledTooltip>
            )}
          </div>
        </div>
      );

    const { firstYearCertified, isCurrentStudent, graduationYear } =
      profile?.educationExperience || {};

    const reliabilityScore = computeReliabilityScore({
      worked: Number(at.shiftsWorked) || 0,
      callouts: Number(at.deCommits) || 0,
      decommits: Number(at.callouts) || 0,
    });

    let credentials = get(at, 'credentials', {});
    const resume = credentials.find((c) => c.type === 'resume');
    credentials = credentials.filter(
      (c) => !['resume', 'npi_number', 'nata_number'].includes(c.type)
    );

    const sortedCredentialKeys = Object.keys(credentials).sort((a, b) => {
      let priorityA = PRIORITY_FILTER[credentials[a].type];
      let priorityB = PRIORITY_FILTER[credentials[b].type];
      if (!priorityA) priorityA = 20;
      if (!priorityB) priorityB = 20;

      return priorityA - priorityB;
    });

    return (
      <div className="experienceModal">
        <div
          className={classNames('plain-button', {
            'feedback-button': this.props.from === 'reviews',
            'modal-button': this.props.from !== 'reviews',
            'upcoming-button': this.props.from === 'upcoming',
          })}
          onClick={this.toggle}
          id={`atName-${reviewId}`}
          ref={this.columnRefs['atName']}
        >
          {this.props.children}
          {this.state.isOverflowing.atName && this.props.from === 'reviews' && (
            <UncontrolledTooltip target={`atName-${reviewId}`}>
              {this.props.children}
            </UncontrolledTooltip>
          )}
        </div>
        <Modal
          isOpen={this.state.open}
          onOpened={this.onOpened}
          toggle={this.toggle}
          className="experience-modal-content"
          size="lg"
        >
          <ModalHeader className="header" toggle={this.toggle}>
            <div>
              <img src={at.profilePic || require('styles/BlankAvatar.svg')} alt={'AT'} />
              <p className="athletic-trainer-name">{at.name}</p>
            </div>
          </ModalHeader>
          <ModalBody>
            <div className="row pb-3">
              <div className="col-md-8">
                <div className="at-container">
                  <div className="at-info">
                    <p>
                      <b>Go4 Shifts:</b>
                      <span>{at?.shiftsWorked}</span>
                    </p>
                    <p>
                      <b>Callouts: </b>
                      <span>{get(at, 'callouts', 0) + get(at, 'deCommits', 0)}</span>
                    </p>
                    <p>
                      <b>Reliability Score</b>
                      <ToolTip
                        id="info"
                        bodyText="This score compares the number of callouts within 7 days of a shift to the number of jobs worked by the AT."
                      />
                      <b>:</b>
                      <span>
                        {reliabilityScore === 'rookie'
                          ? 'Go4 Rookie. No jobs worked yet.'
                          : reliabilityScore + '%'}
                      </span>
                    </p>
                    <p>
                      <b>{companyName} Shifts:</b>
                      <span>{this.state.jobCount}</span>
                    </p>
                    <p>
                      <b>Would I hire again?:</b>
                      <span>{this.state.message}</span>
                    </p>
                  </div>
                  <HorizontalRule dashed margin={10} />
                  {this.showContactInformation() && (
                    <div className="contact-information">
                      <h5>Contact information</h5>
                      <p>
                        <b>Email:</b> <span>{at.email}</span>
                      </p>
                      <p>
                        <b>Phone:</b> <span>{at.phoneNumber}</span>
                      </p>
                      <HorizontalRule dashed margin={10} />
                    </div>
                  )}
                  <div className="credentials">
                    <h5>Credentials</h5>
                    <ul>
                      {at.npiNumber && (
                        <li>
                          <p className="credential-type">
                            NPI Number: <span>{at.npiNumber}</span>
                          </p>
                        </li>
                      )}
                      {at.nataNumber && (
                        <li>
                          <p className="credential-type">
                            NATA Number: <span>{at.nataNumber}</span>
                          </p>
                        </li>
                      )}
                      {sortedCredentialKeys?.map((key, idx) => {
                        return (
                          <li key={idx}>
                            <CredentialModal
                              key={idx}
                              credential={credentials[key]}
                              at={at}
                              usStates={this.props.usStates}
                            />
                          </li>
                        );
                      })}
                    </ul>
                    <div className="actions-container">
                      <AddButton onClick={this.onDownloadAllCredentials} className="at-button">
                        DOWNLOAD ALL CREDENTIALS
                      </AddButton>
                      <DeleteButton onClick={this.toggleIssueModal} className="at-button">
                        REPORT CREDENTIAL ISSUE
                      </DeleteButton>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-4">
                {(profile || resume) && (
                  <div className="experience">
                    <h5>EXPERIENCE</h5>
                    <div className="col-md-12">
                      <p className="experience-item">
                        {`${isCurrentStudent ? 'Graduation year:' : '1st Year Certified:'}`}
                      </p>
                      <p className="item">
                        {isCurrentStudent ? graduationYear : firstYearCertified}
                      </p>
                      <HorizontalRule dashed />
                      {resume && (
                        <>
                          <CredentialModal credential={resume} usStates={this.props.usStates} />
                          {profile && <HorizontalRule dashed />}
                        </>
                      )}
                      {profile && (
                        <React.Fragment>
                          <p className="experience-item">Settings:</p>
                          {profile.settingExperience.fields.map((setting, idx) => {
                            return (
                              <p key={idx} className="item">
                                {setting}
                              </p>
                            );
                          })}
                          <HorizontalRule dashed />
                          <p className="experience-item">Sports:</p>
                          {profile.sportExperience.fields.map((sport, idx) => {
                            return <p key={idx}>{sport}</p>;
                          })}
                        </React.Fragment>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </ModalBody>
          {this.showActions() && (
            <ModalFooter className="actions">
              <button className="btn decline-button" onClick={this.onDecline}>
                DECLINE
              </button>
              <button className="btn accept-button" onClick={this.onApprove}>
                ACCEPT
              </button>
            </ModalFooter>
          )}
        </Modal>
        <CredentialsIssueModal
          isOpen={this.state.issueModalOpen}
          toggle={this.toggleIssueModal}
          job={this.props.job}
          at={at}
          eo={this.props.session.currentUser}
          session={this.props.session}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    usStates: state.enums.usStates,
    companyName: state.session.currentUser.companyName,
    session: state.session,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    downloadAllCredentials: (ATId) => dispatch(downloadAllCredentials(ATId)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ExperienceModal);
